import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { exhaustMap, Observable } from 'rxjs';

import { environment } from '@environments/environment';

import * as models from '../models';
import { DeviceService } from '@helpers/device.service';

@Injectable({
  providedIn: 'root',
})
export class AgentRealPropertyListService {
  constructor(
    private http: HttpClient,
    private _deviceService: DeviceService,
  ) {}

  public getRealPropertyListByRealPropertyAgent(id: models.RealPropertyListByAgentRequest, body: models.RealPropertyListByAgentRequestBody): Observable<models.RealPropertyListByAgentResp> {
    return this._deviceService
      .getDeviceUUID()
      .pipe(
        exhaustMap((deviceUuid) => this.http.post<models.RealPropertyListByAgentResp>(`${environment.apiViewManagerUrl}/open-api/realProperty/getRealPropertiesByAgent/${id}/${deviceUuid}`, body)),
      );
  }
}
